export interface FaqItem {
  id: string;
  question: string;
  answer: string;
}

export const faqItems: FaqItem[] = [
  {
    id: "faq-001",
    question: "佐佐木明希是什么时候出道的？",
    answer: "佐佐木明希于2015年正式出道，至今已有十年演艺生涯。她以清纯的外表和自然的演技迅速赢得了观众的喜爱，在业界取得了卓越的成就。",
  },
  {
    id: "faq-002",
    question: "佐佐木明希的身高和基本信息是什么？",
    answer: "佐佐木明希身高160cm，出生于1988年12月24日，出生地为日本东京都。她隶属于T-POWERS经纪公司，兴趣爱好包括料理、旅行和读书，特长为钢琴和书法。",
  },
  {
    id: "faq-003",
    question: "佐佐木明希出演过多少部作品？",
    answer: "截至目前，佐佐木明希已累计出演超过350部作品，涵盖了剧情、恋爱、职场等多种类型，每年都保持着高质量的产出。",
  },
  {
    id: "faq-004",
    question: "佐佐木明希有哪些代表作品？",
    answer: "佐佐木明希的代表作品包括《あなたに逢いたくて》系列、《禁断の関係》系列以及《初めての体験》系列等。其中2023年末推出的《あなたに逢いたくて》前后篇被公认为她演技的代表作之一。",
  },
  {
    id: "faq-005",
    question: "如何获取佐佐木明希的最新动态？",
    answer: "您可以通过关注本网站的最新动态栏目来获取佐佐木明希的最新资讯。我们会在第一时间更新她的新作品发布、活动信息和各类新闻，确保粉丝不错过任何重要信息。",
  },
  {
    id: "faq-006",
    question: "佐佐木明希获得过哪些奖项？",
    answer: "佐佐木明希在其职业生涯中共获得12个重要奖项，其中包括2024年度最佳女演员大奖等重量级荣誉，充分体现了她在业界的认可度和影响力。",
  },
  {
    id: "faq-007",
    question: "佐佐木明希的写真集在哪里可以购买？",
    answer: "佐佐木明希的最新写真集《綺麗》将于2025年2月14日正式发售。您可以通过各大书店以及线上购物平台进行购买。限量版还附赠特典明信片套装，建议提前关注发售信息。",
  },
  {
    id: "faq-008",
    question: "佐佐木明希会举办粉丝见面会吗？",
    answer: "是的，佐佐木明希每年都会举办粉丝见面会。2024年12月24日，她在东京国际论坛举办了盛大的粉丝见面会，吸引了超过2000名粉丝参加。2025年计划在更多城市举办巡回见面会。",
  },
];